import { useCallback } from 'react'

import { Button, Icon } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { usePermission } from '@circlefin/permissions/react'
import { ADDRESS_BOOK_MUTATION } from '@services/permissions'
import { routes } from '@services/sections/modal/routes'
import useTranslation from 'next-translate/useTranslation'

import type { BlockchainRecipientAddressWithMetadata } from '@shared/graphql'

export interface WalletNicknameProps {
  /*
   * Wallet Nickname.
   */
  nickname: string
  /**
   * Recipient address with metadata.
   */
  recipientAddressWithMetadata: BlockchainRecipientAddressWithMetadata
}

export const WalletNickname: React.FC<WalletNicknameProps> = ({
  nickname,
  recipientAddressWithMetadata,
}) => {
  const { t } = useTranslation('common')
  const modal = useModal()
  const [, { isAuthorized: addressBookMutationAuthorized }] = usePermission(
    ADDRESS_BOOK_MUTATION,
  )

  const openEditRecipientModal = useCallback(() => {
    modal.router.push({
      pathname: routes.account.addressBook.editRecipient,
      query: { recipientAddressWithMetadata },
    })
  }, [modal.router, recipientAddressWithMetadata])

  return (
    <div className="flex items-center space-x-2">
      <p>{nickname}</p>
      {addressBookMutationAuthorized && (
        <Button
          intent="default"
          label={t('edit')}
          onClick={openEditRecipientModal}
          type="button"
          variant="primary"
          iconOnly
        >
          <Icon name="PencilSolid" />
        </Button>
      )}
    </div>
  )
}
